import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as Sentry from "@sentry/react";
import { AuthProvider } from "contexts/JWTContext";
import { SnackBarContextProvider } from "contexts/SnackBarContext";
import useTheme from "hooks/useTheme";
import "i18n";
import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { useRoutes } from "react-router-dom";
import { store } from "redux/store";
import routes from "routes";
import { ThemeProvider } from "styled-components/macro";
import createTheme from "theme";

export default function App() {
  const content = useRoutes(routes) as React.ReactElement;

  const { resolvedTheme } = useTheme();

  return (
    <HelmetProvider>
      <Helmet titleTemplate="%s | Podium" defaultTitle="Podium" />
      <Provider store={store}>
        <SnackBarContextProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <StyledEngineProvider injectFirst>
              <MuiThemeProvider theme={createTheme(resolvedTheme)}>
                <ThemeProvider theme={createTheme(resolvedTheme)}>
                  <Sentry.ErrorBoundary fallback={<React.Fragment />}>
                    <AuthProvider>{content}</AuthProvider>
                  </Sentry.ErrorBoundary>
                </ThemeProvider>
              </MuiThemeProvider>
            </StyledEngineProvider>
          </LocalizationProvider>
        </SnackBarContextProvider>
      </Provider>
    </HelmetProvider>
  );
}
